import * as pp from 'src/utils/page-params';

export function usePageParams() {
  const relations = pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(10)),
    'relations'
  );

  const financialSecurities = pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(10)),
    'financialSecurities'
  );

  return {
    relations,
    financialSecurities,
  };
}

export type PageParams = ReturnType<typeof usePageParams>;
